import styled from "styled-components";
import padding from "@src/presentation/design-tokens/padding";
import fontWeight from "@src/presentation/design-tokens/font-weight";
import margin from "@src/presentation/design-tokens/margin";

export const ContentWrapper = styled.div`
  display: flex;
  flex-flow: column;
`;

export const CallToActionWrapper = styled.div`
  margin-top: ${margin.m4};

  .btn {
    align-items: center;
    display: flex;
    font-size: 1.1rem;
    justify-content: center;
    margin-bottom: ${margin.m3};
    padding: ${padding.p3};
    text-align: center;
    text-transform: uppercase;
    width: 100%;
  }
`;

export const Icon = styled.div`
  font-size: 1.2rem;
  margin-right: ${margin.m3};
`;

export const Logo = styled.img`
  height: 1.2rem;
  margin-right: ${margin.m3};
`;

export const Overlay = styled.div`
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 1040;
`;

export const OverlayLoadingMessage = styled.div``;

export const OverlayLoadingWrapper = styled.div`
  align-items: center;
  background-color: white;
  display: flex;
  flex-flow: column;
  justify-content: center;
  padding: 4rem;

  .spinner-grow {
    margin-bottom: 2rem;
  }
`;

export const Title = styled.div`
  font-size: 1.8rem;
  font-weight: ${fontWeight.bold};
  margin-bottom: ${margin.m3};
`;

export const Wrapper = styled.div`
  .toast-container {
    position: fixed !important;
    z-index: 20000;

    .toast-body {
      font-weight: ${fontWeight.bold};
      font-size: 1rem;
    }
  }
`;

export const TagsWrapper = styled.div`
  align-items: center;
  display: flex;
  margin-bottom: ${margin.m4};
  margin-top: ${margin.m4};

  > div {
    margin-right: ${margin.m6};
  }
`;

export const TagLabel = styled.div`
  font-size: 0.85rem;
  font-weight: ${fontWeight.medium};
  line-height: 1.25;
`;

export const TagText = styled.div`
  font-size: 1.2rem;
  font-weight: ${fontWeight.semibold};
  white-space: nowrap;
`;
